import React from 'react';
import { ColorSwatch } from '@hexcrawl/shared-utils';

interface Props {
  palette: ColorSwatch[];
  selected: string; // hex value
  onChange: (hex: string) => void;
}

export const ColorSwatchPicker: React.FC<Props> = ({ palette, selected, onChange }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {palette.map((swatch) => (
        <button
          key={swatch.id}
          title={swatch.label}
          onClick={() => onChange(swatch.hex)}
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            background: swatch.hex,
            border: selected === swatch.hex ? '2px solid #fff' : '2px solid #555',
            cursor: 'pointer',
            padding: 0,
            outline: selected === swatch.hex ? '2px solid #4CAF50' : 'none',
            outlineOffset: 1,
          }}
        />
      ))}
    </div>
  );
};
